import type { Component } from '../router';
import { getDeviceClass, onDeviceClassChange, type DeviceClass } from '../utils/viewport';

type Factories = {
  phone: () => Component;
  tablet?: () => Component;
  desktop: () => Component;
};

export class ViewportGate implements Component {
  private host: HTMLElement | null = null;
  private active: Component | null = null;
  private current: DeviceClass | null = null;
  private dispose: (() => void) | null = null;

  constructor(private factories: Factories) {}

  mount(host: HTMLElement): void {
    this.host = host;
    this.render(getDeviceClass());
    this.dispose = onDeviceClassChange((dc) => this.render(dc)) as unknown as () => void;
  }

  unmount(): void {
    if (this.active?.unmount) this.active.unmount();
    this.active = null;
    if (this.dispose) this.dispose();
    this.dispose = null;
  }

  private render(dc: DeviceClass): void {
    if (!this.host) return;
    if (dc === this.current) return;
    if (this.active?.unmount) this.active.unmount();
    this.host.innerHTML = '';
    const factory = dc === 'phone' ? this.factories.phone : dc === 'tablet' ? (this.factories.tablet ?? this.factories.desktop) : this.factories.desktop;
    this.active = factory();
    this.active.mount(this.host);
    this.current = dc;
  }
}
